export var OnboardingFlow;
(function (OnboardingFlow) {
    OnboardingFlow["Default"] = "default";
    OnboardingFlow["Social"] = "social";
})(OnboardingFlow || (OnboardingFlow = {}));
//# sourceMappingURL=onboarding-flow.const.js.map